<section>
  <header>
    <h1 mat-dialog-title class="has-icon">
      <i class="History-KyloeIcon"></i>
      {{ruleData.name}}
      <div *ngIf="tasks && tasks[0].scheduledFrequency" class="run-every">
        <i class="material-icons notranslate">alarm</i>
        RUNS EVERY {{tasks[0].scheduledFrequency | TransformRunFrequency}}
      </div>
    </h1>
    <aside>
      <i class="material-icons notranslate close-dialog"
         role="button"
         aria-label="Close"
         tabindex="0"
         [matTooltip]="'Close ' + ruleData.name"
         matTooltipPosition="above"
         [matTooltipShowDelay]="500"
         (click)="onCancelClick()"
         (keydown.enter)="onCancelClick()"
         (keydown.space)="onCancelClick()">close</i>
    </aside>
  </header>
  <div mat-dialog-content>
    <app-skeleton *ngIf="loading" [style]="'big-row-table'" [count]="skeletonBones"></app-skeleton>
    <table class="table-striped scrollable-container" *ngIf="!loading" mat-table [dataSource]="dataSource" #innerTable @appearHeight>
      <!-- INNER COLUMN HEADINGS -->
<!--      <ng-container matColumnDef="entity">-->
<!--        <th mat-header-cell *matHeaderCellDef>Entity</th>-->
<!--        <td mat-cell *matCellDef="let task"-->
<!--            [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}"> {{task.entityLabel}} </td>-->
<!--      </ng-container>-->

<!--      <ng-container matColumnDef="user">-->
<!--        <th mat-header-cell *matHeaderCellDef>User ID</th>-->
<!--        <td mat-cell *matCellDef="let task"-->
<!--            [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}"> {{task.user}} </td>-->
<!--      </ng-container>-->

      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef>User ID</th>
        <td mat-cell *matCellDef="let task"
            [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}"> {{task.user}} </td>
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef>User Name</th>
        <td mat-cell *matCellDef="let task"
            [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}"> {{task.userName || 'N/A'}} </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>State</th>
        <td mat-cell *matCellDef="let task"
            [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}">
          <span>{{task.state}}</span>
          <i *ngIf="task.state === TaskState.RUNNING || task.state === TaskState.STOPPED "
             class="material-icons notranslate play-pause-icon"
             [title]="[task.state === TaskState.QUEUED ? 'Cancel this task':task.state === TaskState.RUNNING ? 'Stop this task' : 'Resume this task']">

            <span *ngIf="task.state === TaskState.STOPPED" (click)="resumeTask(task)" class="green-hover" @fadeButtonInOut>play_arrow</span>
            <span *ngIf="task.state === TaskState.RUNNING" (click)="stopTask(task)" class="red-hover" @fadeButtonInOut>stop</span>
          </i>
        </td>
      </ng-container>
      <ng-container matColumnDef="dateLastRun">
        <th mat-header-cell class="grey-header" *matHeaderCellDef>Date & time of execution</th>
        <td mat-cell *matCellDef="let task" [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}"> {{task.startTime | date:'medium'}} </td>
      </ng-container>
      <ng-container matColumnDef="updated">
        <th mat-header-cell class="grey-header" *matHeaderCellDef>Date & time of last update</th>
        <td mat-cell *matCellDef="let task" [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}"> {{task.updated | date:'medium'}} </td>
      </ng-container>
      <ng-container matColumnDef="totalRecords">
        <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef>Found (Total)</th>
        <td mat-cell class="numeric-cell" *matCellDef="let task">{{task.totalRecords}}</td>
      </ng-container>
      <ng-container matColumnDef="recordsProcessed">
        <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef>Updated</th>
        <td mat-cell class="numeric-cell" *matCellDef="let task">{{task.recordsProcessed}}</td>
      </ng-container>
      <ng-container matColumnDef="noUpdateRequired">
        <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef>No Update Required</th>
        <td mat-cell class="numeric-cell" *matCellDef="let task">{{task.noUpdateRequired ?? '-'}}</td>
      </ng-container>
      <ng-container matColumnDef="recordsFailed">
        <th mat-header-cell class="grey-header numeric-cell" *matHeaderCellDef>Failed</th>
        <td mat-cell class="numeric-cell" *matCellDef="let task" [ngClass]="{'red' : task.recordsFailed > 0}">{{task.recordsFailed}} </td>
      </ng-container>
      <ng-container matColumnDef="revert">
        <th mat-header-cell class="grey-header" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let task" [ngClass]="{'reverted' : task.state === TaskState.ROLLED_BACK}">
          <button *ngIf="canRevert(task)" theme="small" (click)="revertTask(task)">
            <span class="revert"></span>
            <span>Revert</span>
          </button>
        </td>
      </ng-container>
      <!-- INNER COLUMN HEADINGS end -->
      <tr mat-header-row *matHeaderRowDef="innerDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: innerDisplayedColumns;"></tr>
    </table>
    <mat-paginator [pageSize]="5"
                   [pageSizeOptions]="[5, 10, 25]"
                   [selectConfig]="pageSizeSelectConfig"
                   (page)="pageChange($event)"
                   aria-label="Select page">
    </mat-paginator>
  </div>
  <section mat-dialog-actions class="footer-btns one-button">
    <button mat-button (click)="onCancelClick()" theme-style="nav" class="danger-btn-hover" [matTooltip]="'Close `' + ruleData.name + '`'" matTooltipShowDelay="500" appRipple>CLOSE</button>
  </section>
</section>
